module.exports = __webpack_public_path__ + "static/media/2.c4f25e93.jpg";